import { Controller } from "@hotwired/stimulus"
import { Editor, CommandBar } from "tiny-markdown-editor"

// Connects to data-controller="tiny-mde"
export default class extends Controller {
  static targets = ["textarea", "editor", "toolbar"]

  connect() {
    console.log("TinyMDE connected")

    this.editor = new Editor({
      textarea: this.textareaTarget,
      editor: this.editorTarget
    })

    this.commandBar = new CommandBar({
      element: this.toolbarTarget,
      editor: this.editor,
      commands: [
        'bold', 'italic', 'hr', 'blockquote', '|',
        , 'h2', {
          name: 'h3',
          action: 'h3',
          innerHTML: 'h3',
          title: 'Level 3 heading',
        }, 'h4', '|', 'insertLink', '|', 'insertImage',
        {
          name: 'imageUploader',
          title: 'Image Uploader',
          action: () => window.open('/media_items', '_blank'),
          innerHTML: '📷',
        }
      ]
    })
  }

  disconnect() {
    this.editor = null
    this.commandBar = null
  }
}
